module.exports = __webpack_public_path__ + "static/media/miracleExplore.d098fb1c.png";